// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file tagn/v1/common.proto (package tagn.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tagn/v1/common.proto.
 */
export const file_tagn_v1_common: GenFile = /*@__PURE__*/
  fileDesc("ChR0YWduL3YxL2NvbW1vbi5wcm90bxIHdGFnbi52MSJOCgRVc2VyEgoKAmlkGAEgASgJEg0KBWVtYWlsGAIgASgJEhQKDGRpc3BsYXlfbmFtZRgDIAEoCRIVCg1jcmVhdGVkX2F0X21zGAQgASgDYgZwcm90bzM");

/**
 * User is the public representation of an account.
 *
 * @generated from message tagn.v1.User
 */
export type User = Message<"tagn.v1.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: int64 created_at_ms = 4;
   */
  createdAtMs: bigint;
};

/**
 * Describes the message tagn.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_tagn_v1_common, 0);

